"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitTypeMap = exports.unit = void 0;
const types_1 = require("../types");
/**
 * De/Serializer for non-values, i.e. `void`, `()`, `undefined` aka the _unit_ type .
 *
 * @category beet/primitive
 */
exports.unit = {
    write: function (_buf, _offset, _value) { },
    read: function (_buf, _offset) {
        return undefined;
    },
    byteSize: 0,
    description: 'unit',
};
/**
 * Maps unit beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */
exports.unitTypeMap = {
    unit: {
        beet: 'unit',
        isFixable: false,
        sourcePack: types_1.BEET_PACKAGE,
        ts: 'void',
    },
};
//# sourceMappingURL=unit.js.map